import { useContext, useEffect, useMemo, useState } from 'react';

import UserContext from '../../common/utils/getContext';
import { svgSprite, zendoStorage } from '../../hybrid/wrappers';
import { getDataCookies } from '../../common/utils/memo';
import { useWindowDimensions } from '../../common/utils/windowDimensions';
import parse, { domToReact } from 'html-react-parser';
import css from './cookie.module.scss';
import classNames from 'classnames';
import SingleButton from '../form/form-control-buttons/SingleButton/SingleButton';
import { SITE_URL } from '../../common/utils/utils';

const CookieModal = ({}) => {
    const { lang, profile, localization } = useContext(UserContext);
    const widthDimensions = useWindowDimensions();
    const [mobile, setMobile] = useState('');
    const [cookieModalDOM, setCookieModalDOM] = useState('visible');
    const [modalWrapperMode, setModalWrapperMode] = useState('visible');
    const [cookieData, setCookieData] = useState(null);

    const position = cookieData?.position;

    const getCookieData = async () => {
        const cookieData = await getDataCookies();
        setCookieData(cookieData);
    };

    const activeModalStyle = () => {
        if (modalWrapperMode !== 'visible') {
            if (position === 'top') {
                return css.cookieModalWrapperToTop;
            } else {
                return css.cookieModalWrapperToBottom;
            }
        } else {
            return {};
        }
    };

    const closeModalHandler = async () => {
        if (modalWrapperMode === 'visible') {
            setModalWrapperMode('hidden');
            setTimeout(() => {
                setCookieModalDOM('hidden');
            }, 200);
        }
    };

    const handleSendData = async (cookieAgreement) => {
        closeModalHandler();
        getDataCookies.cache.clear();
        zendoStorage.set('cookieAgreement', cookieAgreement);
        getDataCookies.cache.clear();
    };

    useEffect(() => {
        getCookieData();
    }, []);

    useEffect(() => {
        setCookieModalDOM('visible');
        setModalWrapperMode('visible');
    }, [cookieData]);

    useEffect(() => {
        widthDimensions < 768 ? setMobile(true) : setMobile(false);
    }, [widthDimensions]);

    const topLevelDomain = typeof window !== 'undefined' && window.location.host.split('.').pop();

    const [cookieAgreementLink, setCookieAgreementLink] = useState('');

    // якщо домен ru, тоді ru посилання, якщо com тоді дивимось по країні юзера чи локалізації (якщо файл є на сервері віддаємо його посилання), далі дивимось по домену (те саме якщо існує файл), якщо ж він відсутній віддаємо файл kz
    // якщо com тоді дивимось по країні юзера чи локалізації (якщо файл є на сервері віддаємо його посилання)
    // далі дивимось по домену (те саме якщо існує файл), якщо ж він відсутній віддаємо файл kz
    useEffect(() => {
        (async () => {
            const checkExist = async (countryTag) => {
                console.log('countryTag', countryTag);
                try {
                    const response = await fetch('/api/checkfile', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ filePath: `/docs/new/${countryTag}/cookie_agreement.docx` })
                    });
                    const data = await response.json(); // ✅ парсимо JSON
                    console.log('data', data);
                    return data.exists;
                } catch {
                    return false;
                }
            };

            let link = '';
            console.log('topLevelDomain', topLevelDomain);
            if (topLevelDomain === 'ru') {
                link = `${SITE_URL}/docs/new/ru/cookie_agreement.docx`;
            } else if (topLevelDomain === 'com') {
                if (profile?.country?.country || localization?.country?.code) {
                    const isExist = await checkExist(
                        String(profile?.country?.country || localization?.country?.code).toLowerCase()
                    );
                    if (isExist) {
                        link = `${SITE_URL}/docs/new/${String(
                            profile?.country?.country || localization?.country?.code
                        ).toLowerCase()}/cookie_agreement.docx`;
                    } else {
                        link = `${SITE_URL}/page/cookies`;
                    }
                }
            } else {
                let isDocumentExistOnDomain = await checkExist(topLevelDomain);
                if (isDocumentExistOnDomain) {
                    link = `${SITE_URL}/docs/new/${topLevelDomain}/cookie_agreement.docx`;
                } else {
                    link = `${SITE_URL}/page/cookies`;
                }
            }
            setCookieAgreementLink(link);
        })();
    }, [profile, localization, topLevelDomain]);

    // заміняємо посилання з editor-a на потрібне
    // !!! важливо щоб в editor-і посилання містило в собі текст cookie_agreement
    const parserOptions = useMemo(() => {
        return {
            replace: (domNode) => {
                if (domNode.name === 'a' && domNode?.attribs?.href?.includes('cookie_agreement')) {
                    return (
                        <a
                            style={!cookieAgreementLink ? { pointerEvents: 'none' } : {}}
                            href={cookieAgreementLink}
                            target='_blank'
                            rel='noreferrer'
                        >
                            {domToReact(domNode.children)}
                        </a>
                    );
                }
            }
        };
    }, [cookieAgreementLink]);

    if (!cookieData || cookieModalDOM !== 'visible') {
        return null;
    }

    return (
        <div
            className={classNames(
                mobile ? css.cookieModalWrapperMob : css.cookieModalWrapperDesktop,
                position === 'top' ? css.cookieModalWrapperTop : css.cookieModalWrapperBottom,
                activeModalStyle()
            )}
        >
            {mobile ? (
                <div className={css.cookieModalContentWrapperMob}>
                    <div className={css.cookieModalMobileContent}>
                        <div className={css.cookieModalImage}>
                            {svgSprite('cookies-image', {
                                width: 220,
                                height: 150
                            })}
                        </div>
                        <div className={css.cookieModalText}>
                            <div className={css.cookieModalTextContent}>
                                {parse(cookieData?.text ? cookieData?.text[lang] || cookieData?.text.default : '', parserOptions)}
                            </div>
                        </div>
                    </div>
                    <div className={css.cookieModalBtnWrap}>
                        <SingleButton
                            customButton={{ singleButton: css.cookieModalApplyBtn }}
                            type='cancel'
                            buttonText={
                                cookieData?.cancelText ? cookieData?.cancelText[lang] || cookieData?.cancelText.default : ''
                            }
                            clickFunc={() => handleSendData(true)}
                        />
                        <SingleButton
                            customButton={{ singleButton: css.cookieModalApplyBtn }}
                            type='ok'
                            buttonText={cookieData?.applyText ? cookieData?.applyText[lang] || cookieData?.applyText.default : ''}
                            clickFunc={() => handleSendData(true)}
                        />
                    </div>
                </div>
            ) : (
                <div className={css.cookieModalContentWrapper}>
                    <div className={css.cookieModalImage}>{svgSprite('cookies-image', { width: 220, height: 150 })}</div>
                    <div className={css.cookieModalText}>
                        <div className={css.cookieModalTextContent}>
                            {parse(cookieData?.text?.[lang] || cookieData?.text?.default || '', parserOptions)}
                        </div>
                    </div>
                    <div className={css.cookieModalBtnWrap}>
                        <SingleButton
                            customButton={{ singleButton: css.cookieModalApplyBtn }}
                            type='cancel'
                            buttonText={
                                cookieData?.cancelText ? cookieData?.cancelText[lang] || cookieData?.cancelText.default : ''
                            }
                            clickFunc={() => handleSendData(true)}
                        />
                        <SingleButton
                            customButton={{ singleButton: css.cookieModalApplyBtn }}
                            type='ok'
                            buttonText={cookieData?.applyText ? cookieData?.applyText[lang] || cookieData?.applyText.default : ''}
                            clickFunc={() => handleSendData(true)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CookieModal;
